import { C43MediaGalleryProps } from './C43MediaGallery.types';
import { MEDIA_GALLERY_ITEM_COMPONENT_NAME } from 'src/shared/static';
import { MediaGalleryProps, MediaItem } from '@ahc-digital/component-library';
import { GetMediaGalleryItemModel } from '../C43MediaGalleryItem/C43MediaGalleryItem.service';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export function GetMediaGalleryModel(props?: C43MediaGalleryProps): MediaGalleryProps {
  type t = MediaGalleryProps;

  const { fields, params, rendering } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  const marketingRenderingName = useCreateMarketingRenderingHame(
    (rendering?.componentName + 'Slide') as string
  );

  const slidesArray =
    rendering?.placeholders?.['media-gallery-container-{*}']?.filter(
      ({ componentName }) => !!componentName && componentName === MEDIA_GALLERY_ITEM_COMPONENT_NAME
    ) || [];

  const slides: MediaItem[] = slidesArray.map((slide) => ({
    ...GetMediaGalleryItemModel(slide),
    marketingRenderingName,
  }));

  const model: MediaGalleryProps = {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'center'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    shouldHideThumbnails: getCheckbox(params?.HideThumbnails),
    shouldHideNavigation: getCheckbox(params?.HideNavigation),
    slides: slides,
    componentName: marketingRenderingName,
  };

  return model;
}
